export const validatePseudo = (pseudo: string): { isValid: boolean; error?: string } => {
  if (!pseudo || pseudo.trim().length === 0) {
    return { isValid: false, error: 'Pseudo cannot be empty' };
  }

  if (pseudo.length > 16) {
    return { isValid: false, error: 'Pseudo must be 16 characters or less' };
  }

  const trimmedPseudo = pseudo.trim();

  if (trimmedPseudo.length === 0) {
    return { isValid: false, error: 'Pseudo cannot be only whitespace' };
  }

  const basicProfanityList = [
    'fuck',
    'shit',
    'bitch',
    'ass',
    'damn',
    'hell',
    'crap',
    'piss',
    'dick',
    'cock',
    'pussy',
    'bastard',
    'slut',
    'whore',
    'fag',
    'nigger',
    'nigga',
    'retard',
    'nazi',
    'hitler',
  ];

  const lowerPseudo = trimmedPseudo.toLowerCase();

  for (const word of basicProfanityList) {
    if (lowerPseudo.includes(word)) {
      return { isValid: false, error: 'Pseudo contains inappropriate content' };
    }
  }

  const invalidCharsRegex = /[<>{}[\]\\\/]/;
  if (invalidCharsRegex.test(trimmedPseudo)) {
    return { isValid: false, error: 'Pseudo contains invalid characters' };
  }

  return { isValid: true };
};
